import React from 'react';
import { useDispatch } from 'react-redux';
import {Card, CardHeader, CardBody} from 'reactstrap';
import { setTemplateCategories, setTemplateLoader } from '../../../../../../slices/campaigns/reducer';
import { toggleSelectTemplateModal } from '../../../../../../slices/modals/reducer';
import { getTemplate, getTemplateCategory } from '../../../../../../slices/campaigns/thunk';

function SelectFromTemplate() {
  const dispatch = useDispatch();

  async function openSelectTemplateModal() {
    dispatch(setTemplateCategories([]));
    dispatch(toggleSelectTemplateModal());
    dispatch(setTemplateLoader(true));
    await dispatch(getTemplate());
    await dispatch(getTemplateCategory());
    dispatch(setTemplateLoader(false));
  }
  return (
    <Card style={{ minHeight: "330px" }}>
      <CardHeader>Select From Template</CardHeader>
      <CardBody className='d-flex flex-column align-items-center justify-content-center'>
        <div className='mb-3 mt-auto'>
          <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="50.254" height="45.53" viewBox="0 0 50.254 45.53">
            <defs>
              <rect id="Rectangle_70" data-name="Rectangle 70" width="50.254" height="45.53" fill="none" />
            </defs>
            <g id="Group_162" data-name="Group 162" transform="translate(0 0)">
              <g id="Group_162-2" data-name="Group 162" transform="translate(0 0)">
                <path id="Path_49" data-name="Path 49" d="M48.615,1.639A5.413,5.413,0,0,0,44.644,0H5.551A5.324,5.324,0,0,0,1.623,1.639,5.439,5.439,0,0,0,0,5.61V39.979a5.349,5.349,0,0,0,1.623,3.928A5.349,5.349,0,0,0,5.551,45.53H44.644a5.439,5.439,0,0,0,3.971-1.623,5.324,5.324,0,0,0,1.639-3.928V5.61a5.413,5.413,0,0,0-1.639-3.971m-3.971,38.34H5.551V5.61H44.644Z" transform="translate(0 0)" fill="#94F956" />
                <rect id="Rectangle_66" data-name="Rectangle 66" width="26.751" height="3.543" transform="translate(11.752 30.412)" fill="#030541" />
                <rect id="Rectangle_67" data-name="Rectangle 67" width="9.153" height="12.874" transform="translate(11.752 11.574)" fill="#030541" />
                <rect id="Rectangle_68" data-name="Rectangle 68" width="11.752" height="3.543" transform="translate(26.751 20.905)" fill="#94F956" />
                <rect id="Rectangle_69" data-name="Rectangle 69" width="11.752" height="3.543" transform="translate(26.751 11.574)" fill="#94F956" />
                <path id="Path_50" data-name="Path 50" d="M4.7,39.119v0Z" transform="translate(0.851 0.86)" fill="#94F956" />
              </g>
            </g>
          </svg>
        </div>
        <h4>Select from template</h4>
        <button className='btn w-100 btn-soft-primary mb-0 mt-auto' onClick={openSelectTemplateModal}>
          Select From Template
        </button>
      </CardBody>
    </Card>
  )
}

export default SelectFromTemplate
